import { render, staticRenderFns } from "./InlineEditByLaw.vue?vue&type=template&id=a0af6232"
import script from "./InlineEditByLaw.vue?vue&type=script&lang=js"
export * from "./InlineEditByLaw.vue?vue&type=script&lang=js"
import style0 from "./InlineEditByLaw.vue?vue&type=style&index=0&id=a0af6232&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports